module.exports = __webpack_public_path__ + "static/media/user_1.413a3533.png";